module.exports = __webpack_public_path__ + "img/loggigwi2.420e7144.png";